// extracted by mini-css-extract-plugin
export default {"main":"GetConsultation_main__KSUx8","box":"GetConsultation_box__2T40L"};